import React from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'

interface TableLoadingProps {
  message?: string
}

const TableLoading = ({ message = 'Loading...' }: TableLoadingProps) => {
  return (
    <Box
      display='flex'
      flexDirection='column'
      justifyContent='center'
      alignItems='center'
      py={4}
    >
      <CircularProgress />
      {message && (
        <Typography variant='body2' color='text.secondary' sx={{ mt: 2 }}>
          {message}
        </Typography>
      )}
    </Box>
  )
}

export default TableLoading
